import React from "react";
import { Button, Typography, Grid, Box } from "@mui/material";
import { styled } from "@mui/system";
import Header from "../components/Header";
import Background from "../components/Background";
import SubHeader from "../components/SubHeader";
import FactsSection from "../components/FactsSection";
import { secondaryBg, primaryBg } from "../constants/colors";
import Carousel from "../components/Carousel";
import C2 from "../components/C2";
import Item from "../components/carousel/item";
import Amenities from "../components/Amenities";
import Contact from "../components/Contact";

const CenteredContainer = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100vw",
  minHeight: "100vh",
  backgroundColor: primaryBg,
});

const CarouselContainer = styled("div")({
  display: "flex",
  flexDirection: "row",
  overflowX: "scroll",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
});

export default function Home() {
  return (
    <CenteredContainer>
      <Header />
      <Background />
      <SubHeader />
      <Carousel />
      <Amenities />
      <Contact />
    </CenteredContainer>
  );
}
